// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__h4-TY","header":"MessagesList_header__1uXHJ","chat":"MessagesList_chat__Nn8NA"};